/* Flowcart theme — global.js */
document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');

  function setOpen(el, btn, open) {
    if (!el) return;
    el.hidden = !open;
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.hidden;
      setOpen(menu, toggle, open);
      if (open) setOpen(searchPanel, searchToggle, false);
    });
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.hidden;
      setOpen(searchPanel, searchToggle, open);
      if (open) {
        setOpen(menu, toggle, false);
        var field = searchPanel.querySelector('[data-search-panel-input]');
        if (field) field.focus();
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setOpen(menu, toggle, false);
    setOpen(searchPanel, searchToggle, false);
  });

  // Header shadow once scrolled
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Reveal on scroll
  var revealables = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealables.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
      io.observe(el);
    });
  }

  // Buy Now — go straight to a checkout containing only this product.
  //
  // Posting to /cart/add APPENDS to a cart that Shopify keeps for ~14 days, so
  // every abandoned checkout stacked onto the next one: quantities crept up and
  // old products reappeared. The /cart/{variant}:{qty} permalink REPLACES the
  // cart, so each attempt starts clean.
  //
  // Without JS the form still posts to /cart/add?return_to=/checkout, so the
  // button never dies — it just falls back to the old behaviour.
  var buyNowForms = Array.prototype.slice.call(document.querySelectorAll('[data-buy-now]'));
  // The product form is rendered by {% form %}, which can't take a hyphenated
  // data attribute reliably — pick it up by id instead.
  var productForm = document.getElementById('ProductForm');
  if (productForm && buyNowForms.indexOf(productForm) === -1) buyNowForms.push(productForm);

  buyNowForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var idField = form.querySelector('[name="id"]');
      var variantId = idField && idField.value;
      if (!variantId) return;   // nothing selected — let it post normally

      var qtyField = form.querySelector('[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);

      e.preventDefault();
      window.location.href = '/cart/' + encodeURIComponent(variantId) + ':' + qty;
    });
  });

  // Predictive search — suggestions as you type, from Shopify's own endpoint.
  document.querySelectorAll('[data-search-form]').forEach(function (form) {
    var input = form.querySelector('[data-search-input]');
    var results = form.querySelector('[data-search-results]');
    if (!input || !results) return;

    var controller = null;
    var debounce = null;
    var activeIndex = -1;

    function close() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function money(cents) {
      var v = (cents / 100).toFixed(2).split('.');
      var whole = v[0], last3 = whole.slice(-3), rest = whole.slice(0, -3);
      if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
      return '₹' + last3 + '.' + v[1];
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function render(products, query) {
      if (!products.length) {
        results.innerHTML = '<p class="predictive__empty">No products match “' + esc(query) + '”.</p>';
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }

      var items = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var price = '';
        if (p.price != null) {
          // suggest.json returns price as a decimal string, not cents
          var cents = Math.round(parseFloat(p.price) * 100);
          if (!isNaN(cents)) price = money(cents);
        }
        return '<a class="predictive__item" role="option" href="' + esc(p.url) + '">' +
            (img ? '<img class="predictive__img" src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="predictive__img"></span>') +
            '<span class="predictive__text">' +
              '<span class="predictive__title">' + esc(p.title) + '</span>' +
              (price ? '<span class="predictive__price">' + price + '</span>' : '') +
            '</span>' +
          '</a>';
      }).join('');

      results.innerHTML = items +
        '<a class="predictive__all" href="/search?q=' + encodeURIComponent(query) + '">' +
          'See all results for “' + esc(query) + '” →' +
        '</a>';
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    function search(query) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, query);
        })
        .catch(function (err) { if (err.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounce);
      if (query.length < 2) { close(); return; }
      // short enough to feel instant, long enough not to spam the endpoint
      debounce = setTimeout(function () { search(query); }, 160);
    });

    input.addEventListener('keydown', function (e) {
      var options = results.querySelectorAll('.predictive__item, .predictive__all');
      if (e.key === 'Escape') { close(); input.blur(); return; }
      if (!options.length) return;

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex += e.key === 'ArrowDown' ? 1 : -1;
        if (activeIndex < 0) activeIndex = options.length - 1;
        if (activeIndex >= options.length) activeIndex = 0;
        options.forEach(function (o, i) { o.classList.toggle('is-active', i === activeIndex); });
        options[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && activeIndex > -1) {
        e.preventDefault();
        window.location.href = options[activeIndex].getAttribute('href');
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML) {
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  });

  // ---- Spring ---------------------------------------------------------
  // Apple's two-parameter model (damping ratio + response) rather than
  // mass/stiffness/damping. Animates from the current value and keeps its
  // velocity across re-targets, so a gesture can interrupt and reverse it
  // without a visible jump or a velocity "brick wall".
  function Spring(onFrame) {
    var x = 0, v = 0, target = 0, k = 0, c = 0, raf = null, last = 0;

    function tune(damping, response) {
      var omega = 2 * Math.PI / response;
      k = omega * omega;
      c = 2 * damping * omega;
    }
    tune(1, 0.4);

    function tick(now) {
      var dt = Math.min((now - last) / 1000, 1 / 30);
      last = now;
      // fixed sub-steps keep the integration stable on slow frames
      var steps = Math.max(1, Math.ceil(dt / (1 / 600)));
      var h = dt / steps;
      for (var i = 0; i < steps; i++) {
        v += (-k * (x - target) - c * v) * h;
        x += v * h;
      }
      if (Math.abs(x - target) < 0.05 && Math.abs(v) < 0.5) {
        x = target; v = 0; raf = null;
        onFrame(x);
        return;
      }
      onFrame(x);
      raf = requestAnimationFrame(tick);
    }

    return {
      get value() { return x; },
      get velocity() { return v; },
      isAnimating: function () { return raf !== null; },
      stop: function () { if (raf) { cancelAnimationFrame(raf); raf = null; } },
      // 1:1 tracking during a gesture
      set: function (nx) { this.stop(); x = nx; onFrame(x); },
      snap: function (nx) { this.stop(); x = nx; target = nx; v = 0; onFrame(x); },
      to: function (nextTarget, opts) {
        opts = opts || {};
        tune(opts.damping == null ? 1 : opts.damping, opts.response == null ? 0.4 : opts.response);
        target = nextTarget;
        if (opts.velocity != null) v = opts.velocity;   // handoff from the finger
        if (!raf) { last = performance.now(); raf = requestAnimationFrame(tick); }
      }
    };
  }

  // Momentum projection — where the flick is *going*, not where it stopped.
  // Apple's exponential-decay form from Designing Fluid Interfaces.
  function projectMomentum(velocity, decelerationRate) {
    var d = decelerationRate || 0.998;
    return (velocity / 1000) * d / (1 - d);
  }

  // Progressive resistance past the ends instead of a hard stop.
  function rubberband(overshoot, dimension, constant) {
    var cst = constant || 0.55;
    return (overshoot * dimension * cst) / (dimension + cst * Math.abs(overshoot));
  }

  // Generic slider: autoplay, arrows, dots, thumbnails, spring-driven swipe.
  // Used by the hero product carousel and the product-page gallery.
  function initHeroSlider(slider) {
    if (slider.dataset.sliderReady === 'true') return;
    slider.dataset.sliderReady = 'true';

    var track = slider.querySelector('[data-slider-track]');
    var slides = slider.querySelectorAll('[data-slider-slide]');
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    var dotsWrap = slider.querySelector('[data-slider-dots]');
    var thumbs = slider.querySelectorAll('[data-slider-thumb]');
    if (!track || slides.length === 0) return;

    var count = slides.length;
    var index = 0;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = slider.getAttribute('data-autoplay') === 'true' && !reduced && count > 1;
    var interval = parseInt(slider.getAttribute('data-interval'), 10) || 4000;
    var viewport = slider.querySelector('[data-slider-viewport]') || track;

    if (count < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    function width() { return viewport.clientWidth || 1; }
    function restFor(i) { return -i * width(); }

    var spring = Spring(function (x) {
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    });
    spring.snap(restFor(0));

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); restart(); });
    });

    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hero-slider__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (target) {
          dot.addEventListener('click', function () { goTo(target); restart(); });
        })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function paintState() {
      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        var link = s.querySelector('a');
        if (link) link.tabIndex = i === index ? 0 : -1;
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    // velocity is what makes a flick feel thrown rather than nudged
    function goTo(i, velocity) {
      index = (i + count) % count;
      paintState();
      if (reduced) { spring.snap(restFor(index)); return; }
      var flicked = velocity != null && Math.abs(velocity) > 50;
      spring.to(restFor(index), {
        // overshoot only when the user's own gesture carried momentum
        damping: flicked ? 0.8 : 1,
        response: flicked ? 0.35 : 0.4,
        velocity: velocity == null ? undefined : velocity
      });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (autoplay && !timer) timer = setInterval(function () { goTo(index + 1); }, interval); }
    function restart() { stop(); start(); }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); restart(); });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(index - 1); restart(); }
      if (e.key === 'ArrowRight') { goTo(index + 1); restart(); }
    });

    window.addEventListener('resize', function () { spring.snap(restFor(index)); });

    // ---- Gesture --------------------------------------------------------
    var dragging = false, startX = 0, startPos = 0, moved = 0, pointerId = null;
    var samples = [];            // recent {t, x} for release velocity
    var THRESHOLD = 10;          // hysteresis before we commit to a drag

    function sampleVelocity() {
      if (samples.length < 2) return 0;
      var last = samples[samples.length - 1];
      var first = samples[0];
      var dt = (last.t - first.t) / 1000;
      if (dt <= 0) return 0;
      return (last.x - first.x) / dt;   // px/s
    }

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      moved = 0;
      pointerId = e.pointerId;
      startX = e.clientX;
      // grab the element where it *currently* is, mid-flight if need be
      startPos = spring.value;
      spring.stop();
      samples = [{ t: performance.now(), x: e.clientX }];
      stop();
      try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var delta = e.clientX - startX;
      moved = Math.abs(delta);

      samples.push({ t: performance.now(), x: e.clientX });
      if (samples.length > 5) samples.shift();

      var pos = startPos + delta;
      var max = 0, min = restFor(count - 1);
      // soft edges: resist progressively rather than stopping dead
      if (pos > max) pos = max + rubberband(pos - max, width());
      else if (pos < min) pos = min - rubberband(min - pos, width());

      spring.set(pos);
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      if (pointerId != null) {
        try { viewport.releasePointerCapture(pointerId); } catch (err) {}
        pointerId = null;
      }

      var velocity = sampleVelocity();
      if (moved < THRESHOLD) { goTo(index); start(); return; }

      // land where the throw is heading, not where the finger left off
      var projected = spring.value + projectMomentum(velocity);
      var wanted = Math.round(-projected / width());
      wanted = Math.max(0, Math.min(count - 1, wanted));
      goTo(wanted, velocity);
      start();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    // a real drag shouldn't also follow the product link
    viewport.addEventListener('click', function (e) {
      if (moved > THRESHOLD) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    paintState();
    start();
  }

  function initHeroSliders(root) {
    (root || document).querySelectorAll('[data-slider-root], [data-hero-slider]').forEach(initHeroSlider);
  }
  initHeroSliders();
  // the theme editor swaps section markup without reloading the page
  document.addEventListener('shopify:section:load', function (e) { initHeroSliders(e.target); });

  // Quantity steppers. Emits a bubbling 'qty:change' so the cart can react.
  function initSteppers(root) {
    (root || document).querySelectorAll('[data-qty-stepper]').forEach(function (wrap) {
      if (wrap.dataset.stepperReady === 'true') return;
      wrap.dataset.stepperReady = 'true';

      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;

      function commit(value) {
        var v = Math.max(min, value);
        if (String(v) === input.value) return;
        input.value = v;
        input.dispatchEvent(new CustomEvent('qty:change', { bubbles: true, detail: { value: v } }));
      }

      wrap.querySelector('[data-qty-down]').addEventListener('click', function () {
        commit((parseInt(input.value, 10) || min) - 1);
      });
      wrap.querySelector('[data-qty-up]').addEventListener('click', function () {
        commit((parseInt(input.value, 10) || min) + 1);
      });
      input.addEventListener('change', function () {
        commit(parseInt(input.value, 10) || min);
      });
    });
  }
  initSteppers();
  document.addEventListener('shopify:section:load', function (e) { initSteppers(e.target); });

  // Cart: quantity changes save themselves, so there's no "Update cart" button
  var cartRoot = document.querySelector('[data-cart-root]');
  if (cartRoot) {
    var moneyFormat = cartRoot.getAttribute('data-money-format') || '₹{{amount}}';

    function money(cents) {
      var value = (cents / 100).toFixed(2).split('.');
      var whole = value[0];
      var last3 = whole.slice(-3);
      var rest = whole.slice(0, -3);
      if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
      return moneyFormat.replace('{{amount}}', last3 + '.' + value[1]);
    }

    cartRoot.addEventListener('qty:change', function (e) {
      var input = e.target;
      var line = parseInt(input.getAttribute('data-line'), 10);
      if (!line) return;

      var row = input.closest('.cart-item');
      if (row) row.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: e.detail.value })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items[line - 1];
          var totalEl = cartRoot.querySelector('[data-line-total="' + line + '"]');
          if (item && totalEl) totalEl.textContent = money(item.final_line_price);

          var subtotal = cartRoot.querySelector('[data-cart-subtotal]');
          if (subtotal) subtotal.textContent = money(cart.total_price);

          var badge = document.querySelector('[data-cart-count]');
          if (badge) {
            badge.textContent = cart.item_count;
            badge.classList.remove('is-bumped');
            void badge.offsetWidth;
            badge.classList.add('is-bumped');
          }

          // line counts shift when an item disappears — safest to re-render
          if (!cart.item_count || cart.items.length !== cartRoot.querySelectorAll('.cart-item').length) {
            window.location.reload();
          }
        })
        .catch(function () { window.location.reload(); })
        .then(function () { if (row) row.classList.remove('is-updating'); });
    });
  }

  // Variant swatches / size pills
  var form = document.getElementById('ProductForm');
  if (form) {
    var variantSelect = document.getElementById('ProductVariantSelect');
    var dataEl = form.querySelector('[data-variant-data]');
    var optionInputs = form.querySelectorAll('[data-option-input]');
    var variants = [];

    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (err) { variants = []; }
    }

    if (variants.length && optionInputs.length) {
      var priceEl = document.querySelector('[data-product-price]');
      var addBtn = form.querySelector('button[name="add"]');
      var addBtnLabel = addBtn ? addBtn.innerHTML : '';
      var gallerySlider = document.querySelector('.product-gallery__slider');

      function selectedValues() {
        var values = [];
        form.querySelectorAll('[data-variant-option]').forEach(function (group) {
          var checked = group.querySelector('[data-option-input]:checked');
          values.push(checked ? checked.value : null);
        });
        return values;
      }

      function findVariant(values) {
        return variants.filter(function (v) {
          return values.every(function (val, i) {
            return val === null || v['option' + (i + 1)] === val;
          });
        })[0];
      }

      // grey out combinations that don't exist, so people can't pick a dead end
      function markUnavailable(values) {
        form.querySelectorAll('[data-variant-option]').forEach(function (group, gi) {
          group.querySelectorAll('[data-option-input]').forEach(function (input) {
            var probe = values.slice();
            probe[gi] = input.value;
            // only constrain against options chosen before this one
            for (var i = gi + 1; i < probe.length; i++) probe[i] = null;
            var match = variants.filter(function (v) {
              return probe.every(function (val, i) {
                return val === null || v['option' + (i + 1)] === val;
              });
            });
            var possible = match.some(function (v) { return v.available; });
            input.dataset.soldout = possible ? 'false' : 'true';
            var label = group.querySelector('label[for="' + input.id + '"]');
            if (label) label.classList.toggle('is-soldout', !possible);
          });
        });
      }

      function update() {
        var values = selectedValues();
        var variant = findVariant(values);

        form.querySelectorAll('[data-variant-option]').forEach(function (group, gi) {
          var out = group.querySelector('[data-selected-value]');
          if (out && values[gi]) out.textContent = values[gi];
        });

        markUnavailable(values);
        if (!variant) return;

        if (variantSelect) variantSelect.value = variant.id;

        if (priceEl) {
          var current = priceEl.querySelector('.price__current');
          if (current && variant.price != null) {
            current.textContent = formatMoney(variant.price);
          }
        }

        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.innerHTML = addBtnLabel;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold out';
          }
        }

        // jump the gallery to this variant's image
        if (variant.featured_image && gallerySlider) {
          var target = String(variant.featured_image.src || '').split('?')[0].split('/').pop();
          var thumbs = gallerySlider.querySelectorAll('[data-slider-thumb]');
          gallerySlider.querySelectorAll('[data-slider-slide] img').forEach(function (img, i) {
            var name = String(img.currentSrc || img.src).split('?')[0].split('/').pop();
            if (name === target && thumbs[i]) thumbs[i].click();
          });
        }
      }

      function formatMoney(cents) {
        var v = (cents / 100).toFixed(2).split('.');
        var whole = v[0];
        var last3 = whole.slice(-3);
        var rest = whole.slice(0, -3);
        if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
        return '₹' + last3 + '.' + v[1];
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', update);
      });
      update();
    }
  }

  // Sticky add-to-cart bar on product pages (mobile)
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAddBtn = form ? form.querySelector('button[name="add"]') : null;
  if (stickyBar && mainAddBtn && 'IntersectionObserver' in window) {
    var barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    barObserver.observe(mainAddBtn);
  }
});
